import type { ThreeElements } from '@react-three/fiber';
import { folder, useControls } from 'leva';
import * as THREE from 'three';
type PlatformProps = ThreeElements['group'] & {
  rocks_geo: THREE.BufferGeometry;
  platform_geo: THREE.BufferGeometry;
  falloff_geo: THREE.BufferGeometry;
};

export const PlatForm = ({
  rocks_geo,
  platform_geo,
  falloff_geo,
  ...props
}: PlatformProps) => {
  const controls = useControls(
    'platform',
    {
      rocks: folder({
        rockColor: {
          value: '#655353',
        },
      }),
      topside: folder({
        topsideColor: {
          value: '#5c4949',
        },
      }),
      falloff: folder({
        falloffColor: {
          value: '#493c3c',
        },
      }),
    },
    { collapsed: true }
  );

  return (
    <group {...props}>
      <mesh geometry={rocks_geo} receiveShadow>
        <meshStandardNodeMaterial color={controls.rockColor} />
      </mesh>
      <mesh geometry={platform_geo} receiveShadow>
        <meshStandardNodeMaterial color={controls.topsideColor} />
      </mesh>
      <mesh geometry={falloff_geo} receiveShadow>
        <meshStandardNodeMaterial color={controls.falloffColor} />
      </mesh>
    </group>
  );
};
